
import { AssetMaintenanceEntityDecorator } from './asset-maintenance.decorator';
import { AssetMaintenance } from './asset-maintenance.model';
import { CrudTypeInfo } from '@scisys-uim/uim-common';


export abstract class AssetMaintenanceTypeInfoBase implements CrudTypeInfo<AssetMaintenance, number> {
  name = 'Asset Maintenance';
  entityDecorator = new AssetMaintenanceEntityDecorator();
  
  createAuthorities = ['WRITE_ASSET_MAINTENANCE'];
  editAuthorities = ['WRITE_ASSET_MAINTENANCE'];
  deleteAuthorities = ['WRITE_ASSET_MAINTENANCE'];
  viewAuthorities = ['READ_ASSET_MAINTENANCE'];
  
  searchRouteBase = ['/assetmaintenance/search'];
  createRouteBase = ['/assetmaintenance/create'];
  editRouteBase = ['/assetmaintenance/edit'];
  viewRouteBase = ['/assetmaintenance/view'];
  
  description(item: AssetMaintenance): string {
    return '' +  item.assetMaintenanceId;
  }
}



